﻿const icons: Record<string, SVGElement> = Object.create(null);

/**
 * Clones an icon from the collection
 */
function iconLoader(id: string): SVGElement | null {
    const $icon = icons[id];

    return $icon?.cloneNode(true) as SVGElement;
}

/**
 * Stores icon in the icon collection
 */
function storeIcon(id: string, $icon: SVGElement | null): void {
    const $parent = $icon?.parentNode;

    if ($icon && $parent) {
        // Unload icon
        $parent.removeChild($icon);

        // Clean icon
        $icon.id = '';
        $icon.classList.remove('hidden');

        // Save icon in memory
        icons[id] = $icon;
    }
}

/**
 * Loads all available svg icons to memory
 */
export function preloadIcons(): void {
    const $icons = document.querySelectorAll('svg[data-icon]');
    $icons.forEach($icon => {
        const id = $icon.getAttribute('data-icon')!;

        $icon.removeAttribute('data-icon');
        storeIcon(id, $icon as SVGElement);
    });
}

/**
 * Loads an icon from the collection or directly from the DOM
 */
export function loadIcon(id: string): SVGElement | null {
    let $icon = iconLoader(id);

    if ($icon == null) {
        const $el = document.getElementById(id) as SVGElement | null;

        if ($el) {
            storeIcon(id, $icon);

            $icon = iconLoader(id);
        }
    }

    return $icon;
}